<template>
  <div class="scroll_wrapper">
      <section class="main_part">
          <div class="left_images">
              <img src="../assets/galleryPictures/Abstraktus1_w.jpg" class="first_left" />
              <img src="../assets/galleryPictures/ComingToAnEnd2_b_w.jpg" class="second_left" />
              <img src="../assets/galleryPictures/Okdelisch_w.jpg" class="third_left" />
              <img src="../assets/galleryPictures/P1060352.jpg" class="forth_left" />
              <img src="../assets/galleryPictures/WhatRemains_w.jpg" class="fiveth_left" />               
          </div>
          <div class="middle_part">
            <h1 class="aw_heading">Anika Wagner</h1>
            <h2 class="intro_text">Willkommen in meiner Kunstwelt.</h2>
            <router-link to="/galerie" class="gallery_link_button button" @click="activeNav = '0';">            
                <span class="gallery_link">Eintreten</span>
            </router-link>
            <img :src="require('@/assets/AW1.svg')" alt="AW in gemalten Farben" class="aw_symbol"/>
          </div>          
          <div class="right_images">
              <img src="../assets/galleryPictures/Bischl_k_w.jpg" class="first_right" />
              <img src="../assets/galleryPictures/P1060371.jpg" class="second_right" />
              <img src="../assets/galleryPictures/friedvollerFuchs_k_w.jpg" class="third_right" />
              <img src="../assets/galleryPictures/Bienendrache_bw.jpg" class="forth_right" /> 
              <img src="../assets/galleryPictures/Gejagt_w.jpg" class="fiveth_right" />    
          </div>          
      </section>  
      <!-- <div class="fb_link">
          <a href="https://www.facebook.com/anika.wagner.art" target="_blank" rel="noopener noreferrer" title="Anikas Kunstwelt auf FB"><img src="../assets/f_logo_RGB-Blue_58.png" alt="Facebook-Seite Aniksa Kunstwelt"></a>        
      </div> -->
  </div>
</template>

<script lang="ts">
  import { defineComponent, inject, computed } from 'vue';  

  export default defineComponent({
    name: 'HomeView',
    setup() {
        const activeNavItem = inject("activeNavItem") as string;
        const updateNavItem = inject("updateNavItem") as any;
        const activeNav = computed({
            get: () => activeNavItem,
            set: updateNavItem,
        });
        return {
            activeNav
        };
    },
    async beforeCreate() {
        document.body.className = 'home';
    },
    async mounted() 
    {      
      document.documentElement.style.setProperty('--global-backcolor', "#1F1F1F");
    },    
  });
</script>

<style scoped>
@keyframes fadeIn {
  0% {opacity:0;}
  100% {opacity:1;}
}

@-moz-keyframes fadeIn {
  0% {opacity:0;}
  100% {opacity:1;}
}

@-webkit-keyframes fadeIn {
  0% {opacity:0;}
  100% {opacity:1;}
}

@keyframes fadeIn8 {
  0% {opacity:0;}
  100% {opacity:0.8;}
}

@-moz-keyframes fadeIn8 {
  0% {opacity:0;}
  100% {opacity:0.8;}
}

@-webkit-keyframes fadeIn8 {
  0% {opacity:0;}
  100% {opacity:0.8;}
}

@keyframes fadeIn6 {
  0% {opacity:0;}
  100% {opacity:0.6;}
}

@-moz-keyframes fadeIn6 {
  0% {opacity:0;}
  100% {opacity:0.6;}
}

@-webkit-keyframes fadeIn6 {
  0% {opacity:0;}
  100% {opacity:0.6;}
}

body.home {
    background-color: var(--global-backcolor);
}

.aw_heading {
    font-family: "MontserratSubrayada", serif;
    font-weight: 700;
    font-size: 8rem;
    margin-top: 40px;
    margin-left: 20px;
    margin-right: 20px;
    opacity: 0;
    background-color: #1f1f1fb8;
    animation: fadeIn 2s ease 0.2s;
    -webkit-animation: fadeIn 2s ease 0.2s;
    -moz-animation: fadeIn 2s ease 0.2s;
    animation-fill-mode: forwards;
}

.main_part {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    height: 100%;
}

.middle_part {
    width: 100%;
    z-index: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    margin-top: 40px;
    padding-bottom: 40px;
    padding-top: 40px;
}

.intro_text {
    margin-top: 0px;
    opacity: 0;
    animation: fadeIn 2s ease 1s;
    -webkit-animation: fadeIn 2s ease 1s;
    -moz-animation: fadeIn 2s ease 1s;
    animation-fill-mode: forwards;
    z-index: 5;
    font-family: "Yantramanav", sans-serif;
    font-weight: 300;
    font-size: 2rem;
    text-align: center;
    margin-left: 20px;
    margin-right: 20px;
}

.aw_symbol {       
    opacity: 0;
    margin-top: 60px;
    max-height: 80px;
     animation: fadeIn 2.5s ease 1.6s;
    -webkit-animation: fadeIn 2.5s ease 1.6s;
    -moz-animation: fadeIn 2.5s ease 1.6s;
    animation-fill-mode: forwards;
}

.left_images, .right_images {
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: hidden;
}

.right_images {
    position: fixed;
    right: 0;
}

.left_images {
    position: fixed;
    left: 0;
}

.left_images > img, .right_images > img {
    max-width: 300px;
    opacity: 0;
    animation: fadeIn 3s ease 1.5s;
    -webkit-animation: fadeIn 3s ease 1.5s;
    -moz-animation: fadeIn 3s ease 1.5s;
    animation-fill-mode: forwards;
}

.gallery_link_button {
    background-color: var(--global-backcolor);
    z-index: 3;
    font-size: 1rem;
    text-decoration: none;
    padding: 25px;
    font-weight: 300;
    transition: 0.3s;
    opacity: 0;
    border: 1px solid var(--global-color);
    margin-top: 20px;
    margin-bottom: 40px;

    animation: fadeIn 2s ease 1.5s;
    -webkit-animation: fadeIn 2s ease 1.5s;
    -moz-animation: fadeIn 2s ease 1.5s;
    animation-fill-mode: forwards;
}

.gallery_link_button:hover,
.gallery_link_button:focus {
  transform: translateY(-0.25em);
  background-color: #292929;
}

.gallery_link {
    font-size: 1.5em;
    color: var(--global-color);
}

.gallery_link :visited {
    color: inherit;
}

.imageWrapper_start {
    margin-top: 100px;
    margin-bottom: 200px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
}

.imageWrapper_start > img {
    margin-left: 1%;
    margin-right: 1%;
    
}

@media only screen and (max-width: 1070px) {
    
    .imageWrapper_start {
        max-height: 450px;
        overflow: hidden;
    }  
}

@media only screen and (max-width: 920px) {
    .aw_symbol {
        display: none;
    }
}

@media only screen and (max-height: 550px) {
    .aw_symbol {
        display: none;
    }
}

@media only screen and (max-width: 850px) {
    .aw_heading {
        font-size: 4rem;
    }
}

.scroll_wrapper {
    height: 100%;
}

</style>
